<script>
import TopBar from '@components/top-bar'
import Footer from '@components/footer'
import OnlineStatus from "@components/global/OnlineStatus";
import ChatSidebar from "@views/chat/ChatSidebar";
import {mapState} from "vuex";
export default {
  components: { TopBar, Footer, OnlineStatus, ChatSidebar },
  data() {
    return {
      activeSection: 0
    }
  },
  computed:{
    ...mapState({
      selectedUser: state => state.chat.selectedUser,
    })
  },
}
</script>

<style lang="scss">
#chat-home {
  height: 100vh;
  height: 100dvh;
  padding-top: $topbar-height;

  @media (min-width: 768px) {
    padding: calc(#{$topbar-height} + 1rem) 1rem 1rem;
  }
}

.chat-unavailable-wrap {
  min-height: calc(100vh - #{$topbar-height});
  padding: calc(#{$topbar-height} + 1.5rem) 2rem 2rem;
}
</style>
<template>
  <div>
    <header id="topnav">
      <TopBar/>
    </header>
    <div v-if="!isEducational && !isOfflineVersion" id="chat-home" class="tw-overflow-hidden">
      <div class="tw-flex tw-h-full tw-overflow-hidden tw-bg-white md:tw-rounded-2xl md:tw-border md:tw-border-solid md:tw-border-gray-200">
        <chat-sidebar class="tw-w-full md:tw-w-[300px] lg:tw-w-[340px] tw-flex-shrink-0 md:tw-flex md:tw-border-0 md:tw-border-r md:tw-border-solid md:tw-border-gray-200"
                      :class="selectedUser ? 'tw-hidden' : 'tw-flex'"
        />
        <div class="tw-flex-1 tw-min-w-0 md:tw-block" :class="selectedUser ? 'tw-block' : 'tw-hidden'">
          <slot/>
        </div>
      </div>
    </div>
    <div v-else class="chat-unavailable-wrap">
      <educational-unavailable/>
    </div>
<!--      <Footer />-->
      <OnlineStatus/>
  </div>
</template>
